/* -----------------------------------------------------------------------------
 * Security utils functions
 *
 * @description - Some application security utils functions
 * -----------------------------------------------------------------------------
 */

import { _cfg } from '@/config'

/**
 * Get CSRF token
 * @description Returns CSRF token string if present or null
 * @returns {String|null}
 */
function getCSRFToken () {
  const metas = document.getElementsByTagName('meta')
  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === _cfg.security.csrfMetaName) {
      return metas[i].getAttribute('content')
    }
  }
  return null
}

/**
 * Find query param value
 * @description Returns query param value or ''
 * @param {String} search - Given location search
 * @param {String} param - Param name
 * @returns {String}
 */
function findQueryParamVal (search, param) {
  if (!search) return ''
  const params = decodeURIComponent(search.substring(1)).split('&')
  let sParameterName
  for (let i = 0; i < params.length; i++) {
    sParameterName = params[i].split('=')
    if (sParameterName[0] === param) {
      return sParameterName[1] === undefined ? '' : sParameterName[1]
    }
  }
  return ''
}

/**
 * Get query params obj
 * @description Returns query params obj with values from given search
 * @param {String} search - Given location search
 * @returns {Object}
 */
function getQueryParamsObj (search) {
  const cfgParams = _cfg.security.queryParams
  const params = {}
  for (let i = 0; i < cfgParams.length; i++) {
    params[cfgParams[i]] = findQueryParamVal(search, cfgParams[i])
  }
  return params
}

export { getCSRFToken, getQueryParamsObj }
